import React from "react";
import ReactDOM from "react-dom/client";
import { SWRConfig } from "swr";
import "./index.css";
import App from "./App.jsx";
import AuthState from "./components/context/auth/AuthState.jsx";
import DataState from "./components/context/data/DataState";
import { TourProvider } from "@reactour/tour";
import { reactTourSteps } from "./components/helpers/config";
import { swrConfig } from "./services/swrFetcher";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SWRConfig value={swrConfig}>
      <AuthState>
        <DataState>
          <TourProvider
            steps={reactTourSteps}
            styles={{ backgroundColor: "green" }}
            padding={{ popover: 20 }}
          >
            <App />
          </TourProvider>
        </DataState>
      </AuthState>
    </SWRConfig>
  </React.StrictMode>
);

